export function getImageInfo(el) {
    const imageId = el.dataset.tailId;
    const imageWidth = el.clientWidth;
    const imageHeight = el.clientHeight;

    const imageStyles = window.getComputedStyle(el);
    const imageObjectFit = imageStyles.objectFit;
    const imageAspectRatio = imageStyles.aspectRatio;
    const imageObjectPosition = imageStyles.objectPosition;

    const pixelRatioSplit = window.devicePixelRatio.toString().split('.');
    if (pixelRatioSplit.length === 1) {
        pixelRatioSplit[1] = '0';
    }

    let uncodedValues = imageId + '|' + pixelRatioSplit[0] + '|' + pixelRatioSplit[1] + '|' + imageObjectFit + '|' + imageObjectPosition + '|' + imageAspectRatio;
    let codedValues = btoa(uncodedValues);
    codedValues = codedValues.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    return {
        imageWidth,
        imageHeight,
        codedValues,
    };
}

export function changeToResponsiveImage(el) {
    const imageId = el.dataset?.tailId;
    if (imageId && imageId.length > 0 && !Number.isNaN(Number(imageId))) {
        el?.classList.add('tail');
        const { imageWidth, imageHeight, codedValues } = getImageInfo(el);

        if (imageWidth > 0 || imageHeight > 0) {
            let imageUrl = document.body.dataset.tailSrc;
            imageUrl = imageUrl
                .replace('#id#', imageId)
                .replace('#data#', codedValues)
                .replace('#filename#', el.dataset?.tailFilename)
                .replace('#width#', imageWidth)
                .replace('#height#', imageHeight);

            el?.removeAttribute(`data-srcset`);
            el?.removeAttribute(`data-src`);
            el?.removeAttribute(`srcset`);
            el?.removeAttribute(`src`);
            el?.setAttribute('src', imageUrl);
        }
    }
}
